export const debounceDelay = 500;
export const animationRuntime = 301;
export const searchTextMinLength = 2;
export const contentResultsLimit = 3;
export const contentSearchSite = 'thailand_ecommerce';
